import { render, staticRenderFns } from "./DetailInfo.vue?vue&type=template&id=f0fd2a50&scoped=true&"
import script from "./DetailInfo.vue?vue&type=script&lang=ts&"
export * from "./DetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fd2a50",
  null
  
)

export default component.exports